import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-10.807486, 165.822648, 4.8],
  [-10.807571, 165.822744, 4.8],
  [-10.807647, 165.82283, 4.8],
  [-10.807713, 165.822937, 4.8],
  [-10.80777, 165.823045, 4.6],
  [-10.807822, 165.823174, 4.6],
  [-10.807869, 165.823281, 4.6],
  [-10.80791, 165.823399, 4.4],
  [-10.807942, 165.823517, 4.4],
  [-10.807965, 165.823646, 4.6],
  [-10.807983, 165.823764, 4.6],
  [-10.807998, 165.823892, 4.8],
  [-10.808014, 165.82401, 4.8],
  [-10.808035, 165.824128, 4.8],
  [-10.808068, 165.824257, 4.8],
  [-10.808117, 165.824364, 4.8],
  [-10.808179, 165.824472, 4.8],
  [-10.808247, 165.824558, 4.6],
  [-10.808308, 165.824676, 4.4],
  [-10.808347, 165.824783, 4.4],
  [-10.808369, 165.824912, 4.6],
  [-10.808382, 165.82503, 4.8],
  [-10.808391, 165.825158, 5],
  [-10.808401, 165.825276, 5.2],
  [-10.808432, 165.825394, 5.6],
  [-10.808498, 165.825491, 6],
  [-10.808598, 165.825534, 6.4],
  [-10.808708, 165.825555, 6.6],
  [-10.808813, 165.825523, 6.6],
  [-10.808907, 165.825459, 6.4],
  [-10.808986, 165.825362, 6],
  [-10.80906, 165.825276, 5.6],
  [-10.809134, 165.82518, 5],
  [-10.809227, 165.825094, 4.4],
  [-10.809349, 165.825062, 3.8],
  [-10.809473, 165.825105, 3.4],
  [-10.809575, 165.82518, 3.2],
  [-10.809606, 165.825319, 3.8],
  [-10.809583, 165.825448, 4.4],
  [-10.809543, 165.825555, 5.2],
  [-10.809498, 165.825652, 6],
  [-10.809455, 165.825759, 6.6],
  [-10.809412, 165.825866, 7.2],
  [-10.809379, 165.825974, 7.6],
  [-10.809353, 165.82607, 8],
  [-10.80934, 165.826178, 8.4],
  [-10.809342, 165.826285, 8.6],
  [-10.809363, 165.826371, 8.6],
  [-10.809417, 165.826467, 8.6],
  [-10.809503, 165.826532, 8.8],
  [-10.809604, 165.826553, 9.4],
  [-10.809704, 165.826553, 10.2],
  [-10.809801, 165.826542, 10.8],
  [-10.809895, 165.826542, 11.4],
  [-10.809986, 165.826532, 12],
  [-10.810076, 165.826532, 12.4],
  [-10.810166, 165.826532, 12.8],
  [-10.81025, 165.826553, 13],
  [-10.810334, 165.826585, 13],
  [-10.810426, 165.826607, 13.2],
  [-10.810517, 165.826585, 13.6],
  [-10.810607, 165.826553, 14],
  [-10.81069, 165.826532, 14.4],
  [-10.81077, 165.826478, 14.8],
  [-10.810849, 165.826435, 15.4],
  [-10.81093, 165.826403, 15.8],
  [-10.811014, 165.826392, 16.4],
  [-10.811098, 165.826392, 17],
  [-10.811173, 165.826435, 17.2],
  [-10.811232, 165.826499, 17.4],
  [-10.81128, 165.826575, 17.6],
  [-10.811319, 165.82665, 17.8],
  [-10.811349, 165.826735, 18],
  [-10.811373, 165.826821, 18.4],
  [-10.81139, 165.826907, 18.6],
  [-10.811402, 165.827004, 19],
  [-10.811412, 165.82709, 19.4],
  [-10.81142, 165.827186, 19.8],
  [-10.811427, 165.827272, 20.2],
  [-10.811434, 165.827368, 20.6],
  [-10.811433, 165.827454, 21],
  [-10.81142, 165.827529, 21.6],
  [-10.811398, 165.827626, 22.2],
  [-10.811376, 165.827701, 22.6],
  [-10.811353, 165.827776, 23.2],
  [-10.811335, 165.827851, 23.6],
  [-10.811327, 165.827948, 24],
  [-10.811333, 165.828023, 24.4],
  [-10.811356, 165.828098, 24.6],
  [-10.811397, 165.828173, 24.8],
  [-10.811452, 165.828238, 24.8],
  [-10.811523, 165.828302, 25.2],
  [-10.811604, 165.828323, 25.4],
  [-10.811689, 165.828345, 25.8],
  [-10.811773, 165.828377, 26],
  [-10.811843, 165.82842, 26],
  [-10.811897, 165.828495, 26.2],
  [-10.811945, 165.828592, 26.6],
  [-10.81198, 165.828667, 27],
  [-10.811992, 165.828753, 27.6],
  [-10.811981, 165.828849, 28.2],
  [-10.811953, 165.828924, 28.4],
  [-10.81191, 165.828999, 28.6],
  [-10.811859, 165.829074, 28.6],
  [-10.811805, 165.829149, 28.6],
  [-10.811744, 165.829225, 28.8],
  [-10.811671, 165.829289, 28.8],
  [-10.811578, 165.829321, 29],
  [-10.811481, 165.8293, 29],
  [-10.81139, 165.829257, 29],
  [-10.811301, 165.829214, 29.2],
  [-10.811211, 165.829171, 29.2],
  [-10.811113, 165.829117, 29.2],
  [-10.811009, 165.829107, 29.2],
  [-10.810904, 165.829139, 29.4],
  [-10.810814, 165.829192, 29.6],
  [-10.810735, 165.829257, 29.8],
  [-10.810668, 165.829353, 30.2],
  [-10.810613, 165.829439, 30.6],
  [-10.81057, 165.829536, 31],
  [-10.810528, 165.829622, 31.6],
  [-10.810478, 165.829718, 32],
  [-10.810423, 165.829793, 32.4],
  [-10.810365, 165.829868, 32.8],
  [-10.810307, 165.829943, 33.2],
  [-10.810252, 165.830019, 33.6],
  [-10.810185, 165.830083, 34],
  [-10.810106, 165.830126, 34.4],
  [-10.810018, 165.830158, 34.8],
  [-10.809929, 165.830169, 35.2],
  [-10.809839, 165.83019, 35.4],
  [-10.809747, 165.83019, 35.8],
  [-10.809656, 165.83019, 36],
  [-10.809564, 165.830169, 36],
  [-10.809469, 165.830169, 36.2],
  [-10.809375, 165.830158, 36.4],
  [-10.80928, 165.830147, 36.4],
  [-10.809185, 165.830115, 36.6],
  [-10.809094, 165.830083, 36.8],
  [-10.80901, 165.830019, 37],
  [-10.80894, 165.829965, 37.4],
  [-10.808893, 165.829868, 38],
  [-10.80887, 165.829772, 38.6],
  [-10.808868, 165.829686, 39.2],
  [-10.808883, 165.829589, 39.6],
  [-10.808908, 165.829504, 40.2],
  [-10.80894, 165.829428, 40.6],
  [-10.808976, 165.829353, 41],
  [-10.809013, 165.829278, 41.4],
  [-10.809052, 165.829192, 42],
  [-10.80909, 165.829117, 42.4],
  [-10.809126, 165.829042, 42.8],
  [-10.809157, 165.828956, 43.2],
  [-10.809182, 165.828881, 43.8],
  [-10.8092, 165.828795, 44.2],
  [-10.809209, 165.82872, 44.8],
  [-10.809206, 165.828635, 45.2],
  [-10.809182, 165.82857, 45.8],
  [-10.809131, 165.828506, 46.2],
  [-10.809066, 165.828463, 46.4],
  [-10.808991, 165.828431, 46.6],
  [-10.808911, 165.82842, 46.8],
  [-10.808829, 165.82842, 47.2],
  [-10.808746, 165.82842, 47.4],
  [-10.808667, 165.828452, 47.8],
  [-10.808599, 165.828495, 48.4],
  [-10.808545, 165.82857, 48.8],
  [-10.808505, 165.828635, 49],
  [-10.808478, 165.82872, 49.4],
  [-10.808463, 165.828795, 49.6],
  [-10.808467, 165.828892, 50],
  [-10.808493, 165.828967, 50.4],
  [-10.808541, 165.829042, 50.8],
  [-10.808606, 165.829085, 51.2],
  [-10.808679, 165.829139, 51.6],
  [-10.808756, 165.829171, 52],
  [-10.808837, 165.829192, 52.2],
  [-10.808919, 165.829214, 52.6],
  [-10.809004, 165.829225, 52.8],
  [-10.809088, 165.829246, 53.2],
  [-10.809172, 165.829257, 53.4],
  [-10.809253, 165.829289, 53.8],
  [-10.809327, 165.829332, 54.2],
  [-10.809388, 165.829396, 54.8],
  [-10.80943, 165.829471, 55.4],
  [-10.80944, 165.829546, 55.8],
  [-10.809424, 165.829643, 56.4],
  [-10.809394, 165.829718, 56.8],
  [-10.809353, 165.829772, 57],
  [-10.809308, 165.829858, 57.4],
  [-10.809263, 165.829911, 57.6],
  [-10.809216, 165.829986, 57.8],
  [-10.809176, 165.830072, 58.2],
  [-10.809142, 165.830147, 58.4],
  [-10.809121, 165.830233, 58.6],
  [-10.809105, 165.830308, 58.6],
  [-10.809091, 165.830405, 58.8],
  [-10.80908, 165.830491, 58.8],
  [-10.809071, 165.830598, 58.8],
  [-10.809063, 165.830694, 58.8],
  [-10.809058, 165.830802, 58.8],
  [-10.809052, 165.830888, 59],
  [-10.809046, 165.830995, 59],
  [-10.809053, 165.831102, 59.2],
  [-10.809093, 165.831199, 59.6],
  [-10.809154, 165.831274, 60],
  [-10.809223, 165.831349, 60.4],
  [-10.809295, 165.831424, 61],
  [-10.809367, 165.831488, 61.4],
  [-10.809435, 165.831542, 62],
  [-10.809493, 165.831628, 62.4],
  [-10.809534, 165.831703, 63],
  [-10.809542, 165.831789, 63.4],
  [-10.809509, 165.831885, 63.4],
  [-10.809451, 165.831939, 63.4],
  [-10.809378, 165.832003, 63.4],
  [-10.809293, 165.832046, 63.2],
  [-10.809196, 165.8321, 63],
  [-10.809094, 165.8321, 62.8],
  [-10.808986, 165.8321, 62.6],
  [-10.808879, 165.832078, 62.4],
  [-10.808768, 165.832068, 62.2],
  [-10.808658, 165.832036, 62],
  [-10.808545, 165.832003, 61.8],
  [-10.80843, 165.83196, 61.6],
  [-10.808314, 165.831939, 61.4],
  [-10.808195, 165.831928, 61.2],
  [-10.808073, 165.831939, 61.2],
  [-10.807967, 165.831993, 61.4],
  [-10.807893, 165.8321, 61.8],
  [-10.807879, 165.832207, 62.4],
  [-10.807914, 165.832314, 63],
  [-10.807971, 165.8324, 63.6],
  [-10.808032, 165.832497, 64],
  [-10.808093, 165.832583, 64.6],
  [-10.808152, 165.832658, 64.8],
  [-10.808199, 165.832754, 65.2],
  [-10.808226, 165.832862, 65.2],
  [-10.80822, 165.832969, 65.2],
  [-10.808193, 165.833055, 65.8],
  [-10.80815, 165.833162, 66.2],
  [-10.808101, 165.833237, 66.8],
  [-10.808046, 165.833334, 67],
  [-10.807989, 165.833409, 67.2],
  [-10.807928, 165.833484, 67.4],
  [-10.807861, 165.833548, 67.4],
  [-10.807775, 165.833591, 67.4],
  [-10.80768, 165.833602, 67.4],
  [-10.807584, 165.833591, 67.4],
  [-10.807499, 165.833548, 67.4],
  [-10.807423, 165.833484, 67.4],
  [-10.807364, 165.833409, 67.4],
  [-10.807312, 165.833312, 67.4],
  [-10.807236, 165.833259, 67.4],
  [-10.807137, 165.833205, 67.4],
  [-10.807033, 165.833226, 67.4],
  [-10.806948, 165.833291, 67.4],
  [-10.806898, 165.833398, 67.4],
  [-10.806886, 165.833505, 67.4],
  [-10.806892, 165.833602, 67.4],
  [-10.806903, 165.833731, 67.6],
  [-10.80691, 165.833838, 67.6],
  [-10.806894, 165.833945, 67.6],
  [-10.806858, 165.834053, 67.6],
  [-10.80681, 165.83416, 67.4],
  [-10.806757, 165.834267, 67.4],
  [-10.806709, 165.834374, 67.4],
  [-10.806664, 165.834482, 67.2],
  [-10.806619, 165.834578, 67],
  [-10.806574, 165.834707, 67],
  [-10.806526, 165.834814, 66.8],
  [-10.806479, 165.834922, 66.6],
  [-10.806431, 165.83504, 66.4],
  [-10.806383, 165.835147, 66.2],
  [-10.806333, 165.835265, 66],
  [-10.806284, 165.835394, 65.8],
  [-10.806235, 165.835501, 65.6],
  [-10.806185, 165.835619, 65.4],
  [-10.806126, 165.835748, 65.6],
  [-10.806051, 165.835834, 66],
  [-10.805966, 165.83593, 66],
  [-10.805881, 165.836016, 66],
  [-10.805796, 165.836112, 66],
  [-10.805713, 165.836198, 66.2],
  [-10.805631, 165.836295, 66.2],
  [-10.805563, 165.836381, 66],
];

export default stream;
